import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CasesListPage').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    padding: '0px 16px',
    width: '100%',
    overflowY: 'scroll',
    paddingBottom: '60px',
  },

  h1: {
    fontFamily: 'Inter',
    fontWeight: 550,
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    letterSpacing: '-0.01%',
    color: theme.colors.text.primary,
    flexGrow: '1',
    textAlign: 'center',
  },

  caseListHeading: {
    display: 'block',
    width: '100%',
    fontSize: '18px',
    fontWeight: 450,
    lineHeight: '18px',
    textAlign: 'left',
    color: theme.colors.text.primary,
    margin: '0px',
    paddingTop: '24px',
  },

  headingWrapper: {
    width: '90%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },

  goToIcon: {
    position: 'absolute',
    display: 'flex',
    justifySelf: 'flex-start',
  },

  lootBoxWrapper: {
    width: '100%',
  },
}))
